import { formatISODate } from "../common/utils";

export const goalieGameColumns = [
  { dataIndex: "rinkName", title: "Rink" },
  { dataIndex: "date", title: "Date/Time", render: (val: string) => formatISODate(val) },
  { dataIndex: "team1Name", title: "Home Team" },
  { dataIndex: "team1GoalieName", title: "Home Goalie", render: (val?: string) => val || "—" },
  { dataIndex: "team2Name", title: "Away Team" },
  { dataIndex: "team2GoalieName", title: "Away Goalie", render: (val?: string) => val || "—" }
];
